<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="corp_name"
        label="企业名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="corp_user_name"
        label="员工名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="detre(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { phoneRelationindex, phoneRelationstoredelte } from '@/api/mobilePhoneScanningCode.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        phone_id: '',
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(id) {
      this.query.phone_id = id
      this.list()
    },
    async list() {
      const data = await phoneRelationindex(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    detre(id) {
      this.$confirm('此操作将删除此条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        phoneRelationstoredelte({ id: id }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.list()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
